<div class="chat-container">
    <ng-container *ngFor="let message of messages">
        <div class="chat-msg">
            <!-- {{message.role}} -->
            <div [innerHTML]="message.content" *ngIf="message.type === 'html'" class="styled-table">
            </div>
            <div *ngIf="message.type !== 'html'" class="{{message.role}}">
                <!-- <pre>{{message.content}}</pre> -->
                <p [innerHTML]="message.content | newline" class="wrap-text"></p>
            </div>
            <!-- <p >{{message.content | newline}}</p> -->
        </div>
    </ng-container>
    <div class="chat-msg" *ngIf="assistantMessage.length">
        <div class="assistant">
            <p [innerHTML]="assistantMessage | newline" class="wrap-text"></p>
        </div>
    </div>
    <div class="chat-msg">

        <div class="input-container">
            <textarea class="message-input" [(ngModel)]="userMessage" (keydown.enter)="sendMessage()"
                placeholder="Ask a question about the document"></textarea>
            <button class="send-button" (click)="sendMessage()">Send</button>
        </div>
    </div>

    <div id="loader" *ngIf="loadingFlag"></div>